import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterBranch", "listTypes"];
import { ensureEmptyORWrapper } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class FlowList extends createImmutableObjectClass({
  portalId: null,
  listId: null,
  listTypes: [],
  flowId: null,
  filterBranch: null
}, {
  fromJSON: _ref => {
    let {
        filterBranch,
        listTypes
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, {
      listTypes,
      filterBranch: filterBranch ? ensureEmptyORWrapper(listTypes, filterBranch) : filterBranch
    });
  },
  toJSON: record => record
}) {
  toAssociatedListInterface() {
    return {
      portalId: this.portalId,
      listId: this.listId,
      flowId: this.flowId,
      filterBranch: this.filterBranch,
      listTypes: [...this.listTypes]
    };
  }
}